var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6668 8.66673C6.9531 9.04948 7.31837 9.36618 7.73783 9.59535C8.1573 9.82452 8.62114 9.9608 9.0979 9.99495C9.57466 10.0291 10.0532 9.9603 10.501 9.79325C10.9489 9.62619 11.3555 9.36477 11.6935 9.02673L13.6935 7.02673C14.3007 6.39805 14.6366 5.55604 14.629 4.68205C14.6215 3.80807 14.2709 2.97202 13.6529 2.354C13.0348 1.73597 12.1988 1.38541 11.3248 1.37781C10.4508 1.37022 9.60881 1.7062 8.98013 2.31339L7.83347 3.45339M9.33347 7.33339C9.04716 6.95064 8.68189 6.63394 8.26243 6.40477C7.84297 6.17559 7.37913 6.03931 6.90237 6.00517C6.4256 5.97102 5.94708 6.03981 5.49924 6.20687C5.0514 6.37393 4.64472 6.63534 4.3068 6.97339L2.3068 8.97339C1.69961 9.60207 1.36363 10.4441 1.37122 11.3181C1.37881 12.1921 1.72938 13.0281 2.3474 13.6461C2.96543 14.2641 3.80147 14.6147 4.67546 14.6223C5.54945 14.6299 6.39146 14.2939 7.02013 13.6867L8.16013 12.5467",
    stroke: "#A9A9A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_1737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.5f133431afb9760b498d5d419ca9568e.svg";
export { ForwardRef as ReactComponent };